import { styled, css } from 'next-yak'

import * as colors from '../../constants/colors'
import * as fonts from '../../constants/fonts'
import * as inputStyle from './input'

export type Status = 'error' | 'success' | 'default'

const focusedBorder = css`
  border: ${({ theme }) => `1px solid ${(theme as any)?.colors?.primary ?? colors.PRIMARY_BLUE_500}`};
`

export const TextArea = styled.textarea<{ $resizable?: boolean; $status?: Status }>`
  border-radius: 2px;
  padding: 15px;
  font-family: ${fonts.PRIMARY_FONT};
  font-size: 15px;
  font-weight: 400;
  outline-color: ${colors.PRIMARY_BLUE_500};
  background-color: ${colors.PRIMARY_GREY_000};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;

  &:focus {
    ${focusedBorder};
    outline: none;
  }

  &::placeholder {
    font-family: ${fonts.PRIMARY_FONT};
    color: ${colors.TEXT_TERTIARY};
    font-size: 15px;
    font-weight: 400;
  }

  ${({ $resizable = true }) => {
    if (!$resizable) {
      return css`
        resize: none;
      `
    }
  }}

  ${({ $status }) => {
    if ($status === 'error') {
      return css`
        ${inputStyle.errorBorder}
      `
    }
    if ($status === 'success') {
      return css`
        ${inputStyle.successBorder}
      `
    }
    return css`
      ${inputStyle.defaultBorder}
    `
  }}

  &:disabled {
    ${inputStyle.defaultBorder}
    color: ${colors.TEXT_TERTIARY};
    background-color: ${colors.SECONDARY_GREY_400};
  }
`

export const Count = styled.span<{ $isError: boolean }>`
  font-size: 10px;
  font-family: ${fonts.PRIMARY_FONT};
  font-weight: 500;
  ${({ $isError }) => {
    if ($isError) {
      return css`
        color: ${colors.SECONDARY_RED_500};
      `
    } else {
      return css`
        color: ${colors.TEXT_SECONDARY};
      `
    }
  }}
`
